import { render, staticRenderFns } from "./Uazapi.vue?vue&type=template&id=01f5c53f&"
import script from "./Uazapi.vue?vue&type=script&lang=js&"
export * from "./Uazapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports